import React, { FC, useMemo } from 'react';
import { H1 as Text } from './styles';
import { Colors } from 'theme/colors';
import { useTheme } from '@emotion/react';

export interface H2Props {
    variant?: keyof Colors;
    grey?: number;
    center?: boolean;
    className?: string;
}

const H2: FC<H2Props> = ({ children, variant, grey, center, className }) => {
    const theme = useTheme();
    const color = useMemo(() => (variant ? theme.colors[variant] : grey ? theme.greys[grey] : theme.colors.white), [variant, grey]);

    return (
        <Text color={color} center={center} className={className}>
            {children}
        </Text>
    );
};

export default H2;
